import { OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';

export enum PlaybackState {
  Play = 'Play',
  Pause = 'Pause',
  Reset = 'Reset',
  Finish = 'Finish',
}

export interface IAudioService extends OnDestroy {
  elapsedSeconds$: Observable<number>;
  duration$: Observable<number>;
  loaded$: Observable<boolean>;
  state$: Observable<PlaybackState>;

  play();
  pause();
  reset();
  setCurrentTime(currentTime: number);
}
